import { BehaviorSubject } from 'rxjs';

export const pageLoaderState = new BehaviorSubject<Set<string>>(new Set());

export const setPageLoader = (uniqueKey: string, loading: boolean) => {
  const next = new Set(pageLoaderState.value);
  loading ? next.add(uniqueKey) : next.delete(uniqueKey);
  pageLoaderState.next(next);
};
